// webadmin sends an event's description as plain text: paragraphs separated by
// blank lines, and now and then a "- " bullet list. The event page body draws
// EventBodyBlocks, so this turns one into the other.
import type { EventBodyBlock } from "./events";

const BULLET = /^-\s+(.+)$/;

/**
 * Split a description into body blocks: a paragraph per blank-line-separated
 * chunk (its lines flowed together with spaces), and one list per run of "- "
 * lines. A blank line ends a paragraph but not a list, because webadmin puts
 * blank lines between bullets too.
 */
export function descriptionBlocks(description: string | undefined): EventBodyBlock[] {
  const blocks: EventBodyBlock[] = [];
  let paragraph: string[] = [];
  let list: string[] = [];
  const endParagraph = () => {
    if (paragraph.length) blocks.push({ text: paragraph.join(" ") });
    paragraph = [];
  };
  const endList = () => {
    if (list.length) blocks.push({ list });
    list = [];
  };

  for (const raw of (description ?? "").split(/\r\n|\r|\n/)) {
    const line = raw.trim();
    if (!line) {
      endParagraph();
      continue;
    }
    const bullet = BULLET.exec(line);
    if (bullet) {
      endParagraph();
      list.push(bullet[1]);
      continue;
    }
    endList();
    paragraph.push(line);
  }
  endParagraph();
  endList();
  return blocks;
}
